import { Component, inject, OnInit, signal } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { RagService } from './pages/rag/services/rag.service';
import { ChatPersistenceService } from './core/services/chat-persistence.service';
import { SideNavigationComponent } from './components/side-navigation/side-navigation.component';
import { AuthService } from './core/services/auth.service';
import { SettingsSyncService } from './core/services/settings-sync.service';
import { ChatSyncService } from './core/services/chat-sync.service';

@Component({
  imports: [RouterOutlet, SideNavigationComponent],
  selector: 'app-root',
  styleUrl: './app.scss',
  templateUrl: './app.html',
})
export class App implements OnInit {
  private readonly rag = inject(RagService);
  private readonly router = inject(Router);
  protected readonly chatPersistence = inject(ChatPersistenceService);
  protected readonly auth = inject(AuthService);
  private readonly settingsSync = inject(SettingsSyncService);
  private readonly chatSync = inject(ChatSyncService);
  protected readonly navigationCollapsed = signal(false);

  ngOnInit() {
    // Load persisted RAG documents from IndexedDB once at startup
    this.rag.loadDocuments();
    this.navigationCollapsed.set(localStorage.getItem('navigation-collapsed') === 'true');
    void this.settingsSync.load();
    void this.chatSync.start();
  }

  protected setNavigationCollapsed(collapsed: boolean): void {
    this.navigationCollapsed.set(collapsed);
    localStorage.setItem('navigation-collapsed', String(collapsed));
  }

  protected startNewChat(): void {
    const thread = this.chatPersistence.createThread();
    void this.router.navigate(['/chat', thread.id]);
  }

  protected async signOut(): Promise<void> {
    await this.auth.signOut();
    if (!this.auth.user()) await this.router.navigate(['/auth/login']);
  }
}
